import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { debounce, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import adminAPi from "../../../utils/adminAPi";
import { FeAutocomplete } from "../../FormElements";
import FeTextField from "../../FormElements/FeTextField";

const ResponseRateForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [formValue, setFormValue] = useState({
    value: "",
    group: "Progression site",
    type: "Clinical",
  });

  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState("");

  const options = [
    {
      label: "RECIST 1.1",
      value: "Clinical",
    },
    {
      label: "iRECIST",
      value: "Radiological",
    },
    {
      label: "Pathological",
      value: "Pathological",
    },
  ];
  const [type, setType] = useState(options[0]);
  useEffect(() => {
    if (id) {
      getDetails(id);
    }
  }, []);
  function convertEmptyStringToNull(obj) {
    const newObj = {};

    for (let key in obj) {
      newObj[key] = obj[key] === "" ? null : obj[key];
    }

    return newObj;
  }
  async function getDetails(id) {
    const { data } = await adminAPi.get(`admin/response-rate-records/${id}`);
    setFormValue(data.data);
    setType(options.find((o) => o.value === data.data.type));
  }

  const handleField = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleSubmit = async (e) => {
    const updatedData = convertEmptyStringToNull(formValue);
    e.preventDefault();
    try {
      setErrors({});
      setErrorMsg("");
      if (id) {
        console.log("AAAA", updatedData);
        const { data } = await adminAPi.put(
          `admin/response-rate-records/${id}`,
          updatedData
        );
        navigate(pathname.substring(0, pathname.lastIndexOf("/")));
      } else {
        console.log("AAAA", updatedData);
        const { data } = await adminAPi.post(
          "admin/response-rate-records",
          updatedData
        );
        navigate(pathname.substring(0, pathname.lastIndexOf("/")));
      }
    } catch ({ response }) {
      console.log(response);
      if (response) {
        const { data } = response;
        if (data && data.errors) {
          setErrors(data.errors);
        }

        if (data && data.message) {
          setErrorMsg(data.message);
        }
      }
    }
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <FeAutocomplete
              getOptionLabel={(option) => option.label}
              onChange={(e, v) => {
                // handleChangeInput("gender", v);
                setType(v);
                setFormValue({ ...formValue, type: v.value });
              }}
              value={type}
              options={options}
              disableClearable
              id="Sex"
              label="Type"
            />
          </Grid>
          <Grid item sm={4}>
            <FeAutocomplete
              onChange={(e, v) => {
                // handleChangeInput("gender", v);
                setFormValue({ ...formValue, group: v });
              }}
              value={formValue.group ? formValue.group : ""}
              options={["Progression site", "Method of Estimation"]}
              id="Sex"
              label="Type"
            />
          </Grid>
          <Grid item sm={4}>
            <FeTextField
              name="value"
              id="value"
              label="Value"
              value={formValue.value ? formValue.value : ""}
              onChange={handleField}
            />
          </Grid>
        </Grid>

        <Box
          display="flex"
          justifyContent="flex-start"
          flexDirection={"column"}
          mt={2}
        >
          {!isEmpty(errors) && (
            <>
              {Object.keys(errors).map((o, j) => {
                return (
                  <Typography
                    key={j}
                    variant="subtitle2"
                    gutterBottom
                    sx={{ color: "red" }}
                  >
                    {errors[o][0]}
                  </Typography>
                );
              })}
            </>
          )}
          {!isEmpty(errorMsg) && (
            <Typography variant="subtitle2" gutterBottom sx={{ color: "red" }}>
              {errorMsg}
            </Typography>
          )}
        </Box>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button type="submit" variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
export default ResponseRateForm;
